/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonSharedAcademicEducationDropdownQueryResponse,
  GetApiV1PersonSharedAcademicEducationDropdown401,
  GetApiV1PersonSharedAcademicEducationDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedAcademicEducationDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonSharedAcademicEducationDropdown } from "../../clients/personSharedController/getApiV1PersonSharedAcademicEducationDropdown.ts";

export const getApiV1PersonSharedAcademicEducationDropdownQueryKey = () =>
  [{ url: "/api/v1/person/shared/academic-education-dropdown" }] as const;

export type GetApiV1PersonSharedAcademicEducationDropdownQueryKey = ReturnType<
  typeof getApiV1PersonSharedAcademicEducationDropdownQueryKey
>;

export function getApiV1PersonSharedAcademicEducationDropdownQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonSharedAcademicEducationDropdownQueryKey();
  return queryOptions<
    GetApiV1PersonSharedAcademicEducationDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedAcademicEducationDropdown401
      | GetApiV1PersonSharedAcademicEducationDropdown500
    >,
    GetApiV1PersonSharedAcademicEducationDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonSharedAcademicEducationDropdown({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as opções do enumerador EAcademicEducation para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de formações acadêmicas para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/academic-education-dropdown}
 */
export function useGetApiV1PersonSharedAcademicEducationDropdown<
  TData = GetApiV1PersonSharedAcademicEducationDropdownQueryResponse,
  TQueryData = GetApiV1PersonSharedAcademicEducationDropdownQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1PersonSharedAcademicEducationDropdownQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonSharedAcademicEducationDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonSharedAcademicEducationDropdown401
          | GetApiV1PersonSharedAcademicEducationDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonSharedAcademicEducationDropdownQueryKey();

  const query = useQuery(
    {
      ...getApiV1PersonSharedAcademicEducationDropdownQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonSharedAcademicEducationDropdown401
      | GetApiV1PersonSharedAcademicEducationDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
